const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const variantMatchesColor = (variant, colorValue) => {
  if (Array.isArray(variant.options)) {
    return variant.options.includes(colorValue);
  }
  return [variant.option1, variant.option2, variant.option3].includes(colorValue);
}

const getVariantFeaturedMedia = (variant) => {
  if (variant.featured_media) return variant.featured_media;
  if (!variant.featured_image) return null;

  const featuredImage =
    typeof variant.featured_image === "string"
      ? { src: variant.featured_image }
      : variant.featured_image;

  return {
    alt: featuredImage.alt,
    preview_image: {
      src: featuredImage.src,
      width: featuredImage.width || 1000,
      height: featuredImage.height || 1000,
    },
  };
}

const findVariantByColor = (product, colorValue) => {
  return product.variants.find((variant) => {
    const media = getVariantFeaturedMedia(variant);
    return media && variantMatchesColor(variant, colorValue);
  });
}

const productJsonCache = new Map();

const fetchProductJson = (handle) => {
  if (!handle) return Promise.resolve(null);
  if (productJsonCache.has(handle)) return productJsonCache.get(handle);

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const request = fetch(`${root}products/${handle}.js`)
    .then((response) => (response.ok ? response.json() : null))
    .catch(() => null);

  productJsonCache.set(handle, request);
  return request;
};

const swapCardImageForVariant = (wrapper, product, colorValue) => {
  const primaryImage = wrapper.querySelector(".media--first");
  const secondaryImage = wrapper.querySelector(".media--second");
  if (!primaryImage || !product) return;

  const variant = findVariantByColor(product, colorValue);
  const variantMedia = variant ? getVariantFeaturedMedia(variant) : null;
  if (!variantMedia) return;

  const newPrimaryImage = createImageElement(
    variantMedia,
    primaryImage.className,
    primaryImage.sizes,
    product.title
  );

  if (newPrimaryImage.src === primaryImage.src) return;

  let flag = false;
  if (secondaryImage) {
    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

    if (secondaryImagePathname == newPrimaryImagePathname) {
      primaryImage.remove();
      secondaryImage.classList.remove("media--second");
      secondaryImage.classList.add("media--first");
      flag = true;
    }
  }

  if (flag == false) {
    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
    setTimeout(function () {
      primaryImage.replaceWith(newPrimaryImage);
      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
      if (secondaryImage) {
        secondaryImage.remove();
      }
    }, 200);
  }
};

const applySwatchSelection = (wrapper, input) => {
  const link = wrapper.querySelector(".js-color-swatches-link");
  if (link && input.dataset.variantLink) {
    link.setAttribute("href", input.dataset.variantLink);
  }

  const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
  if (addButton) {
    addButton.setAttribute("aria-disabled", false);
    const addLabel = addButton.querySelector("span");
    if (addLabel) {
      addLabel.classList.remove("hidden");
      const soldOut = addButton.querySelector(".sold-out-message");
      if (soldOut) soldOut.classList.add("hidden");
    }
    const idInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
    if (idInput && input.dataset.variantId) {
      idInput.value = input.dataset.variantId;
    }
  }

  const handleProduct = wrapper.dataset.product;
  const currentColor = input.value;
  if (!handleProduct || !currentColor) return;

  fetchProductJson(handleProduct).then((product) => {
    if (product) swapCardImageForVariant(wrapper, product, currentColor);
  });
};

const bindSwatchInput = (wrapper, input) => {
  if (input.dataset.swatchBound === "true") return;
  input.dataset.swatchBound = "true";

  const onSwatchActivate = () => {
    if (input.type === "radio" && !input.checked) {
      input.checked = true;
    }
    if (!input.checked) return;
    applySwatchSelection(wrapper, input);
  };

  input.addEventListener("change", onSwatchActivate);
  input.addEventListener("click", onSwatchActivate);

  const label = wrapper.querySelector(`label[for="${input.id}"]`);
  if (label) {
    label.addEventListener("mouseenter", () => {
      if (input.type === "radio") input.checked = true;
      onSwatchActivate();
    });
  }
};

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      bindSwatchInput(wrapper, input);
    });
  });
}

const checkRecentlyViewedBadges = () => {
  const RECENTLY_VIEWED_KEY = "rocco_recently_viewed_products";
  const recentlyViewedHandles = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || "[]");
  
  document.querySelectorAll('.badge--recently-viewed').forEach(badge => {
    if (recentlyViewedHandles.includes(badge.dataset.productHandle)) {
      badge.style.display = '';
    }
  });
};

function colorSwatches() {
  checkSwatches();
  checkRecentlyViewedBadges();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
    checkRecentlyViewedBadges();
  });
}

(function () {
colorSwatches();
})();

window.initColorSwatches = checkSwatches;
